"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "empoli": {
    "42a03548": [{
      "hkey": "3ff7a18d",
      "slug": "pozzale-casenuove",
      "name": "Pozzale-Casenuove",
      "primary": true,
      "skipSearch": false
    }],
    "casenuove": [{
      "hkey": "3ff7a18d",
      "slug": "pozzale-casenuove",
      "name": "Pozzale-Casenuove",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "empoli"
    }],
    "0c73cf10": [{
      "hkey": "9bd2c1e0",
      "slug": "sant-andrea-fontanella",
      "name": "Sant'Andrea-Fontanella",
      "primary": true,
      "skipSearch": false
    }],
    "fontanella": [{
      "hkey": "9bd2c1e0",
      "slug": "sant-andrea-fontanella",
      "name": "Sant'Andrea-Fontanella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "empoli"
    }],
    "45312bb7": [{
      "hkey": "3ff7a18d",
      "slug": "pozzale-casenuove",
      "name": "Pozzale-Casenuove",
      "primary": true,
      "skipSearch": false
    }],
    "pozzale": [{
      "hkey": "3ff7a18d",
      "slug": "pozzale-casenuove",
      "name": "Pozzale-Casenuove",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e2ad6fe9": [{
      "hkey": "9bd2c1e0",
      "slug": "sant-andrea-fontanella",
      "name": "Sant'Andrea-Fontanella",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "9bd2c1e0",
      "slug": "sant-andrea-fontanella",
      "name": "Sant'Andrea-Fontanella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;